import { render } from "./cjabnormalCall.vue?vue&type=template&id=d97063b6&scoped=true"
import script from "./cjabnormalCall.vue?vue&type=script&lang=js"
export * from "./cjabnormalCall.vue?vue&type=script&lang=js"

import "./cjabnormalCall.vue?vue&type=style&index=0&id=d97063b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d97063b6"

export default script